/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from "./InventoryView.css";
import ContentHeader from 'legacy/containers/ContentHeader';
import FormattedDate from 'legacy/components/FormattedDate'
import { getDateFormat } from 'legacy/constants'
import {
    fetchMe,
    fetchTeamInventoryReports,
    fetchInventory,
    fetchTeamInventoryReportUsage
} from 'legacy/containers/ApiUrls';
import {checkInventoryReportsFeatureEnabled, checkInventoryFeatureEnabled} from 'configs/index'
import EcgLoader from 'legacy/containers/EcgLoader';
import CustomSingleSelectComboBox from '../../components/Common/FormMUIWrapperComponents/CustomSingleSelectComboBox';
import { SELECT_FIELD_CONST } from '../../components/Common/FormMUIWrapperComponents/CustomSingleSelect/Constants'
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent'

import PageTab from 'legacy/components/PageTab'
import PageTabs from 'legacy/components/PageTabs'
// import CustomTableComponent from '../../components/Common/Table/CustomTableComponent'

import { Table } from 'antd';
import 'antd/dist/antd.css';
// import '../../components/Common/Table/CustomTableComponent/CustomTableComponent.css';
import TableHeader from '../../components/Common/Table/TableHeader';

const InventoryView = () => {
    const dispatch = useDispatch();
    const me = useSelector(state => state.app.dataSources.me);
    const isBackOfficeAdmin = me && me.data && me.data.profile.permissions.isBackOfficeAdmin
    const dateFormat = getDateFormat(me)
    const [CurrentPageTab, setCurrentPageTab] = useState("INVENTORY_VIEW") // INVENTORY_VIEW, HIERARCHY_VIEW
    const [PageLoaded, setPageLoaded] = useState(false)
    const [ReportContentLoaded, setReportContentLoaded] = useState(false)
    const [TableData, setTableData] = useState([])
    const [InventoryData, setInventoryData] = useState({})
    const [Sortbyteam, setSortbyteam] = useState({})
    const [Hierarchy, setHierarchy] = useState({})
    const [ChildUseage, setChildUseage] = useState({})
    
    const [Error, setError] = useState(false)


    useEffect(() => {
        if(!me.data && me.fetching == false){
            dispatch(fetchMe());
        }
    }, [])

    useEffect(() => {
        if(me.data){
            setPageLoaded(true)
        }
    }, [me])
    
    useEffect(async () => {
        if(PageLoaded){
            // Page Loaded 
            if (CurrentPageTab == "INVENTORY_VIEW") {
                setReportContentLoaded(false)
                const Data = await dispatch(fetchInventory(me.data.teams[0].id,me.data.teams[0].id))
                let sortByTeam = {}
                let sortByInventory = {}
                Data && Data.map(d => {
                    sortByTeam[d.parentTeamID] = {
                        "connectionInventoryID": "",
                        "parentTeamID": "",
                        "key": `${d.parentTeamID}_${d.teamID}`,
                        "parentTeamName": "",
                        "teamID": d.parentTeamID,
                        "teamName": d.parentTeamName,
                        "orderID": "==========",
                        "connectionTemplateID": "",
                        "connectionTemplateName": "====================",
                        "allocatedConnectionsCount": (sortByTeam[d.parentTeamID] && sortByTeam[d.parentTeamID].allocatedConnectionsCount) ? sortByTeam[d.parentTeamID].allocatedConnectionsCount + d.allocatedConnectionsCount : d.allocatedConnectionsCount,
                        "generatedCodeCount": (sortByTeam[d.parentTeamID] && sortByTeam[d.parentTeamID].generatedCodeCount) ? sortByTeam[d.parentTeamID].generatedCodeCount + d.generatedCodeCount : d.generatedCodeCount,
                        "redeemedCodeCount": (sortByTeam[d.parentTeamID] && sortByTeam[d.parentTeamID].redeemedCodeCount) ? sortByTeam[d.parentTeamID].redeemedCodeCount + d.redeemedCodeCount : d.redeemedCodeCount,
                        "expiresAt": "",
                        "createdAt": "",
                        "children": (sortByTeam[d.parentTeamID] && sortByTeam[d.parentTeamID].children) ? [...sortByTeam[d.parentTeamID].children, d] : [d]
                    }
                    sortByInventory[d.connectionInventoryID] = d
                })
                setInventoryData(sortByInventory)
                setTableData(Object.values(sortByTeam))
                setSortbyteam(sortByTeam)
                setReportContentLoaded(true)
            }
            if (CurrentPageTab == "HIERARCHY_VIEW") {
                setReportContentLoaded(false)
                const UsageData = await dispatch(fetchTeamInventoryReportUsage(me.data.teams[0].id,me.data.teams[0].id))
                if( UsageData && UsageData.errors ){ setReportContentLoaded(true); setError(true) }
                else {
                    const {hierarchy, usage} = UsageData
                    const teamUsage = usage.reduce((acc, item) => {
                        acc[item.teamID] = acc[item.teamID] || [];
                        acc[item.teamID].push({...item, teamName: item.parentTeamName});
                        return acc;
                    }, {});
                    let hierarchyParentTeamUsage = {}
                    hierarchy.map(d => {
                        Sortbyteam[d.parentTeamId] && Sortbyteam[d.parentTeamId].children && Sortbyteam[d.parentTeamId].children.map(c => {
                             const index = teamUsage[d.childTeamId] && teamUsage[d.childTeamId].findIndex(t => t.connectionInventoryID == c.connectionInventoryID)
                            if(index == -1){
                                teamUsage[d.childTeamId].push({...c, generatedCodeCount: 0, redeemedCodeCount: 0, available: c.allocatedConnectionsCount - c.generatedCodeCount})
                            } else if (teamUsage[d.childTeamId]){
                                teamUsage[d.childTeamId][index] = {...teamUsage[d.childTeamId][index], available: c.allocatedConnectionsCount - c.generatedCodeCount}
                            }
                        })
                        const childData = {
                            "connectionInventoryID": "",
                            "parentTeamID": d.parentTeamId,
                            "key": `${d.parentTeamId}_${d.childTeamId}`,
                            "parentTeamName": d.parentName,
                            "teamID": d.childTeamId,
                            "teamName": d.childName,
                            "orderID": "==========",
                            "connectionTemplateID": "",
                            "connectionTemplateName": "====================",
                            "available": teamUsage[d.childTeamId] ? teamUsage[d.childTeamId].reduce((a,o)=> a+o.available,0) : "-",
                            "allocatedConnectionsCount": teamUsage[d.childTeamId] ? teamUsage[d.childTeamId].reduce((a,o)=> a+o.allocatedConnectionsCount,0) : "-",
                            "generatedCodeCount": teamUsage[d.childTeamId] ? teamUsage[d.childTeamId].reduce((a,o)=> a+o.generatedCodeCount,0) : "-",
                            "redeemedCodeCount": teamUsage[d.childTeamId] ? teamUsage[d.childTeamId].reduce((a,o)=> a+o.redeemedCodeCount,0) : "-",
                            "expiresAt": "",
                            "createdAt": "",
                            "children": teamUsage[d.childTeamId] ? teamUsage[d.childTeamId] : [{"parentTeamID":"No inv","teamName":"No Inventory Consumed"}]
                        }
                        hierarchyParentTeamUsage[d.parentTeamId] =  {
                            "connectionInventoryID": "",
                            "parentTeamID": "",
                            "key": `${d.parentTeamId}`,
                            "parentTeamName": "",
                            "teamID": d.parentTeamId,
                            "teamName": d.parentName,
                            "orderID": "==========",
                            "connectionTemplateID": "",
                            "connectionTemplateName": "====================",
                            "allocatedConnectionsCount": "-",
                            "generatedCodeCount": "-",
                            "redeemedCodeCount": "-",
                            "expiresAt": "",
                            "createdAt": "",
                            "children": (hierarchyParentTeamUsage[d.parentTeamId] && hierarchyParentTeamUsage[d.parentTeamId].children) ? [...hierarchyParentTeamUsage[d.parentTeamId].children, childData] : [childData]
                        }
                    })
                    setHierarchy(hierarchy)
                    setChildUseage(usage)
                    setTableData(Object.values(hierarchyParentTeamUsage))
                    setReportContentLoaded(true)
                }
            }
        }
    }, [PageLoaded, CurrentPageTab])

    // Table Row Object :
    // {
    //     "connectionInventoryID": "a9azrR8qdiwaoXmVaJUqcl8r5wibcnxe",
    //     "parentTeamID": "vtq22bdnpDCN9Vc3F620cl8qzs0xvnkg",
    //     "parentTeamName": "GE MUSE - Staging",
    //     "teamID": "vtq22bdnpDCN9Vc3F620cl8qzs0xvnkg",
    //     "teamName": "GE MUSE - Staging",
    //     "orderID": null,
    //     "connectionTemplateID": "ARJrvJ0UY3AUUyz8HGN9cl8r2pgqdklg",
    //     "connectionTemplateName": "30-Day License",
    //     "allocatedConnectionsCount": 96,
    //     "generatedCodeCount": 2,
    //     "redeemedCodeCount": 6,
    //     "expiresAt": "2022-08-05T17:34:45.554688Z",
    //     "createdAt": "2022-07-06T17:34:45.554693Z"
    // }

    const InventoryViewTableColumns = [
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="&nbsp;"
                    keyMap="createdAt"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            width: 5,
            render: (text, record, index) => {
                const data = record.createdAt && `${record.createdAt}`;
                return (
                <p>

                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Practice"
                    keyMap="teamName"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'teamName',
            width: 200,
            key: 'teamName',
            // width: 100,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                const data = record.teamName && `${record.teamName}`;
                if (!record.parentTeamID) {
                    return (
                        <b>
                            {data}
                        </b>
                    );
                } else {
                    return (
                        <p>
                            {data}
                        </p>
                    );
                }
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Short Description"
                    keyMap="connectionTemplateName"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'connectionTemplateName',
            width: 200,
            key: 'connectionTemplateName',
            // width: 100,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                // if (text) {
                //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
                // }
                const data = record.connectionTemplateName && `${record.connectionTemplateName}`;
                return (
                <p>
                    {data}
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Order Id"
                    keyMap="orderID"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'orderID',
            key: 'orderID',
            // width: 100,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                // if (text) {
                //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
                // }
                const data = record.orderID ? `${record.orderID}` : ' -';
                return (
                <p>
                    {data}
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Purchased"
                    keyMap="allocatedConnectionsCount"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'allocatedConnectionsCount',
            key: 'allocatedConnectionsCount',
            width: 85,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                // if (text) {
                //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
                // }
                const data = record.allocatedConnectionsCount && `${record.allocatedConnectionsCount}`;
                return (
                <p>
                    {data}
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Available"
                    keyMap="allocatedConnectionsCount"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'allocatedConnectionsCount',
            key: 'allocatedConnectionsCount',
            width: 85,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                // if (text) {
                //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
                // }
                let available = record.available ? record.available : (record.allocatedConnectionsCount && record.allocatedConnectionsCount - record.generatedCodeCount);
                const data = available ? `${available}` : ' -';
                return (
                <p>
                    {data}
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Pending"
                    keyMap="generatedCodeCount"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                />
                );
            },
            dataIndex: 'generatedCodeCount',
            key: 'generatedCodeCount',
            width: 85,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                // if (text) {
                //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
                // }
                const pending = record.generatedCodeCount && record.generatedCodeCount - record.redeemedCodeCount;
                const data = pending ? `${pending}` : ' -';
                return (
                <p>
                    {data}
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Redeemed"
                    keyMap="redeemedCodeCount"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'redeemedCodeCount',
            key: 'redeemedCodeCount',
            width: 85,
            // sorter: (a, b) => a.last_name && a.last_name.localeCompare(b.last_name),
            render: (text, record, index) => {
                // if (text) {
                //   return <Radio checked={record.radioCheck}  key={index} >{text}</Radio>;
                // }
                const data = record.redeemedCodeCount ? `${record.redeemedCodeCount}` : ' -';
                return (
                <p>
                    {data}
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Purchase Date"
                    keyMap="createdAt"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'createdAt',
            width: 110,
            key: 'createdAt',
            render: (text, record, index) => {
                const data = record.createdAt && `${record.createdAt}`;
                return (
                <p>
                    <FormattedDate date={data} fmt={dateFormat} me={me}/>
                </p>
                );
            },
        },
        {
            title: ({ sortOrder, sortColumn, filters }) => {
                return (
                <TableHeader
                    headerTxt="Expiry Date"
                    keyMap="expiresAt"
                    enableFilterRow={false}
                    enableFilter={false}
                    filterFunction={() => {}}
                    sortOrder={sortOrder}
                    sortColumn={sortColumn}
                    headerEnrollTable={true}
                />
                );
            },
            dataIndex: 'expiresAt',
            width: 110,
            key: 'expiresAt',
            render: (text, record, index) => {
                const data = record.expiresAt && `${record.expiresAt}`;
                return (
                <p>
                    <FormattedDate date={data} fmt={dateFormat} me={me}/>
                </p>
                );
            },
        },
    ]


    if (PageLoaded && !(checkInventoryReportsFeatureEnabled(me).enabled || checkInventoryFeatureEnabled(me).enabled) || !isBackOfficeAdmin) {
        return (
          <div data-page="add-new-patienth" className={styles.addNewPatient}>
            <AccessDeniedContent
              title="Inventory"
            />
          </div>
        )
      }
  
    
    return (
        <React.Fragment>
            <div data-page="Inventory" className={styles.InventoryViewPage}>
                <ContentHeader
                    isLoading={me.isFetching}
                    showLastRefresh={false}
                    text="Inventory"
                    me={me}
                    showAddPatient={false}
                    enableBackButton={false}
                    isFullWidth={true}
                />
                <div className={styles.container}>
                    { (!PageLoaded || !ReportContentLoaded) ? <div className={styles.loaderPage}><EcgLoader /></div> : 
                    (!Error ? (<div className={styles.page}>
                        <React.Fragment>
                            <PageTabs>
                                <PageTab
                                dataAction="inventory"
                                isActive={CurrentPageTab === "INVENTORY_VIEW"}
                                handleOnClick={() => setCurrentPageTab("INVENTORY_VIEW")}
                                getLabel={() => 'Inventory View'}
                                />
                                {checkInventoryReportsFeatureEnabled(me).enabled && <PageTab
                                dataAction="hierarchy"
                                isActive={CurrentPageTab === "HIERARCHY_VIEW"}
                                handleOnClick={() => setCurrentPageTab("HIERARCHY_VIEW")}
                                getLabel={() => 'Hierarchy View'}
                                />}
                            </PageTabs>
                        </React.Fragment>
                        {CurrentPageTab === "INVENTORY_VIEW" &&
                            <React.Fragment>
                                <h1 className={styles.sectionTitle}>Inventory</h1>
                                <span className={styles.sectionCaption}>Showing inventory of {TableData.length} practice(s)</span>
                                {TableData.length > 0 ?(
                                <React.Fragment>
                                    {/* Data Table */}
                                    <Table
                                        styles={{marginTop:'30px'}}
                                        key="invTable"
                                        columns={InventoryViewTableColumns}
                                        dataSource={TableData}
                                        pagination={false}
                                    />
                                </React.Fragment> ) : (
                                    <React.Fragment>
                                        <h1 className={`${styles.title} ${styles.loaderPage}`}> 
                                            {checkInventoryReportsFeatureEnabled(me).enabled ? 'No Inventory Reports Found' : 'No Inventory Found'}
                                            <br/> <small>Contact Administrator</small> 
                                        </h1>
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        }
                        {CurrentPageTab === "HIERARCHY_VIEW" &&
                            <React.Fragment>
                                <h1 className={styles.sectionTitle}>Practice Hierarchy</h1>
                                <span className={styles.sectionCaption}>Select Practice to view inventory usage</span>
                                {TableData.length > 0 ?(
                                <React.Fragment>
                                    {/* Data Table */}
                                    <Table
                                        styles={{marginTop:'30px'}}
                                        key="invTable"
                                        columns={InventoryViewTableColumns}
                                        dataSource={TableData}
                                        pagination={false}
                                    />
                                </React.Fragment> ) : (
                                    <React.Fragment>
                                        <h1 className={`${styles.title} ${styles.loaderPage}`}> 
                                            {checkInventoryReportsFeatureEnabled(me).enabled ? 'No Inventory Reports Found' : 'No Inventory Found'}
                                            <br/> <small>Contact Administrator</small> 
                                        </h1>
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        }
                    </div>) : (<div className={styles.loaderPage}><h1>Error Fetching Inventory</h1></div>))
                    }
                </div>
            </div>
        </React.Fragment>
    );
}

export default InventoryView


// WEBPACK FOOTER //
// ./src/views/pages/InventoryView/InventoryViewOld.jsx